
import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    contetnArrange: {
        width: '100%',
        padding: '5px 20px',
        marginTop: "-315px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
    },
    boxCorner:{
        borderRadius: '25px',
        background: '#fff',
        padding: '0px 20px 5px 20px',
        width: '100%',
        height: '50%',
        boxSizing: 'border-box',
        '& img': {
            borderRadius: 4,
        },
        '& > div > div': {
            height: '250px !important'
        }
    }
}));

export default style;
